module.exports = __webpack_public_path__ + "static/media/ministry_of_justice.1e7581cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ministry_of_justice.png
// module id = 503
// module chunks = 0